import { createAction } from "@reduxjs/toolkit";
import { commonActionTypes } from "../actionTypes/commonSurveyActionTypes";

export const discardAction = createAction(commonActionTypes.discard);
